/** The subset of a product needed to resolve a part number. */
export interface ProcurementSkuSource {
  source?: string;
  sku?: string;
  vendorPartNumber?: string;
}

/**
 * The part number a customer sees. Mirrors procurementSku() in aitryx-customer
 * — keep the two in step, or the storefront preview stops matching the
 * storefront.
 *
 * For distributor-sourced products `sku` holds the distributor's own part
 * number (Ingram's IPN, Dicker's PartNumber), which is a sync key rather than
 * something we publish, so those resolve to `vendorPartNumber`. Manual
 * products carry the vendor's part number in `sku` because the partner typed
 * it there.
 */
export function procurementSku(item: ProcurementSkuSource): string | null {
  const isManual = item.source?.trim().toLowerCase() === 'manual';
  const resolved = isManual ? item.sku : item.vendorPartNumber;
  return resolved?.trim() || null;
}
